export type MaskProps = 'cep' | 'cpf' | 'cnpj' | 'phone' | 'date' | 'brl';

const process = (mask: string, value: string) => {
  const arrayMask = mask.split('');
  const arrayValue = String(value).split('');

  return arrayMask.reduce((acc, curr) => {
    if (arrayValue.length) {
      if (curr === '9') {
        return acc + arrayValue.shift();
      }
      return acc + curr;
    }
    return acc;
  }, '');
};

export const transformValue = (value: string) => {
  if (!value) {
    return '';
  }
  return String(value).replace(/[\s()-//.]/g, '');
};

export const unMask = (value: string) => {
  return String(value).replace(/[^\d]/g, '');
};

export const masks = {
  cep: (value: string) => {
    const pure = transformValue(value);
    return process('99999-999', pure);
  },
  cpf: (value: string) => {
    const pure = transformValue(value);
    return process('999.999.999-99', pure);
  },
  cnpj: (value: string) => {
    const pure = transformValue(value);
    return process('99.999.999/9999-99', pure);
  },
  phone: (value: string) => {
    const pure = transformValue(value || '');

    if (pure.length < 11) {
      return process('(99) 9999-9999', pure);
    }
    return process('(99) 99999-9999', pure);
  },
  date: (value: string) => {
    const pure = transformValue(value);
    return process('99/99/9999', pure);
  },
  brl: (value: string) => {
    const pure = unMask(value);
    const numericValue = parseFloat(pure) / 100;

    if (isNaN(numericValue)) {
      return 'R$ 0,00';
    }

    return numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  },
};

export default class Mask {
  static format(maskType: MaskProps, value: string) {
    const mask = masks[maskType];
    return mask ? mask(value) : value;
  }

  static unMask(value: string) {
    return value.replace(/[^\d]/g, '');
  }

  static canApplyMask(maskType: string) {
    return maskType in masks ? true : false;
  }
}
